"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8816],{

/***/ 28816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Slider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/icons/NextArrow.tsx


var NextArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2383 7.90674L27.3316 16.0001L19.2383 24.0934",
                stroke: "white",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.66797 16H27.108",
                stroke: "white",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var icons_NextArrow = (NextArrow);

;// CONCATENATED MODULE: ./src/views/Project/components/Slider/Slider.tsx
// Import Slick React components





var CustomNextArrow = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        onClick: onClick,
        className: "__customArrow absolute right-[5rem] h-[72px] w-[72px] rounded-full top-[50%] translate-y-[-50%] z-[10] cursor-pointer hidden select-none lg:flex items-center justify-center hover:!bg-[rgba(134,0,15,1)] duration-300",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_NextArrow, {})
    });
};
var CustomPrevArrow = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        onClick: onClick,
        className: "__customArrow absolute left-[5rem] h-[72px] w-[72px] rounded-full top-[50%] translate-y-[-50%] z-[10] cursor-pointer hidden select-none lg:flex items-center justify-center hover:!bg-[rgba(134,0,15,1)] duration-300 rotate-180",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_NextArrow, {})
    });
};
var SlickSlider = function(param) {
    var children = param.children, show = param.show, xlShow = param.xlShow, xxxlShow = param.xxxlShow, draggable = param.draggable, move = param.move, swipe = param.swipe;
    var sliderSettings = {
        customPaging: function customPaging(i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block w-full h-full rounded-full"
            });
        },
        dots: true,
        dotsClass: "slick-dots",
        speed: 500,
        infinite: true,
        slidesToShow: show,
        Draggable: draggable,
        swipeToSlide: move,
        touchMove: swipe,
        slidesToScroll: 1,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPrevArrow, {}),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomNextArrow, {}),
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1279,
                settings: {
                    slidesToShow: xlShow
                }
            },
            {
                breakpoint: 1919,
                settings: {
                    slidesToShow: xxxlShow
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
            children: children
        }))
    });
};
/* harmony default export */ var Slider = (SlickSlider);


/***/ })

}]);